module.exports = __webpack_public_path__ + "images/category_lp/audio_instrument/new/assessment_achievements/2@2x_9915faca9ea3b7574108e8496f67d0cd.png";